import React from 'react';
import {
  NoWidgetsContainer,
  NoWidgetsText,
  NoWidgetsTitle
} from '../WidgetList/WidgetList.style';
import { Title } from '../../styled components/Typography';

export default (props) => {
  const { title, text } = props;
  return (
    <NoWidgetsContainer>
      <Title as="p">
        <span role="img" aria-label="">
          👋
        </span>
      </Title>
      <NoWidgetsTitle>{title}</NoWidgetsTitle>
      <NoWidgetsText>{text}</NoWidgetsText>
    </NoWidgetsContainer>
  );
};
